import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const ParentContainer = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const ParentGrid = styled(Grid)(({ theme, isBelowLargeScreen, isHomeView }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: isBelowLargeScreen ? '100%' : isHomeView ? '100%' : '1600px',
  marginTop: '15px'
}));

const TitleContainer = styled(Grid)(({ isBelowLargeScreen }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'none'
}));

const FindYourTypography = styled(Typography)(({ theme }) => ({
  fontSize: '36px',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '40px',
  letterSpacing: '0.25px',
  marginRight: '8px',
  color: '#000000',
  [theme.breakpoints.down('md')]: {
    fontSize: '26px'
  }
}));

const PerfectMatchTypography = styled(Typography)(({ theme }) => ({
  fontSize: '46px',
  fontStyle: 'normal',
  fontFamily: 'Space Grotesk',
  fontWeight: 500,
  lineHeight: '40px',
  letterSpacing: '0.25px',
  color: '#000000',
  [theme.breakpoints.down('lg')]: {
    fontSize: '26px',
    fontWeight: 500,
    marginBottom: '-10px'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '24px',
    fontWeight: 500
  }
}));

const DescriptionTypography = styled(Typography)({
  textAlign: 'center',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 400,
  fontFamily: 'Inter',
  lineHeight: '24px',
  letterSpacing: '0.25px',
  maxWidth: '900px',
  color: '#000000',
});

export { DescriptionTypography, FindYourTypography, ParentContainer, ParentGrid, PerfectMatchTypography, TitleContainer };

